<template>
  <base-loader :loading="loadingContent">
    <project-performance-component
      :header="tableHeader"
      :performance-data="data"
    />
  </base-loader>
</template>

<script>
  import ProjectPerformanceComponent from "../../components/projects/ProjectPerformanceComponent"
  import Project from "../../services/Projects";

  export default {
    name: 'ProjectPerformance',
    components: {
      ProjectPerformanceComponent
    },
    data () {
      return {
        data: [],
        projectId: null,
        loadingContent: false
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('projects.performanceTable.name'),
          this.$t('projects.performanceTable.worked'),
          this.$t('projects.performanceTable.approved'),
          this.$t('projects.performanceTable.performance'),
        ])
      },
    },
    methods: {
      getProjectPerformance () {
        this.loadingContent = true;
        Project.getPerformance(this.projectId).then(data => {
          const performanceData = data.users_performance;
          performanceData.push({
            class: 'hrsys-total',
            name: this.$t('projects.performanceTable.overall'),
            total_worked: data.total_worked,
            to_approve: data.to_approve,
            approved_hours: data.approved_hours,
            performance: data.performance,
          });
          this.data = performanceData;
        }).finally(() => {
          this.loadingContent = false;
        });
      }
    },
    mounted () {
      this.projectId = parseInt(this.$route.params.id);
      this.getProjectPerformance()
    }
  }
</script>

<style scoped>

</style>
